import React, { PropsWithChildren } from 'react';
import { Box, Heading, VStack } from '@medely/ui-kit';
import { config } from '@mp/config';
import { HelpCenterLink } from '@mp/components';
import { useCurrentUser } from '@mp/hooks';

type PerformanceTabContentProps = PropsWithChildren<{ title: string }>;

export const PerformanceTabContent = ({ children, title }: PerformanceTabContentProps) => {
  const { isAgency } = useCurrentUser();

  const helpLink = isAgency
    ? config.help.communityGuidelinesAgency
    : config.help.communityGuidelines;

  return (
    <Box testId="performance-tab-content">
      <Heading size="xs">{title}</Heading>
      {children}

      <VStack alignItems="flex-end" pb={2} testId="profile-review-guidelines">
        <HelpCenterLink text="Review guidelines" url={helpLink} />
      </VStack>
    </Box>
  );
};
